var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          {
            class: [
              "content navigation bg-light",
              { expanded: !_vm.isSidebarOpen },
            ],
          },
          [
            _c("div", [
              _c(
                "div",
                {
                  class: { active: !_vm.showReconcile },
                  on: {
                    click: function ($event) {
                      _vm.reconciliationObject != null
                        ? (_vm.showReconcile = false)
                        : ""
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-regular fa-list" }),
                  _vm._v("\n          Reconciliation Ledger\n        "),
                ]
              ),
              _vm._v(" "),
              _vm.reconciliationObject != null
                ? _c(
                    "div",
                    {
                      class: { active: _vm.showReconcile },
                      on: {
                        click: function ($event) {
                          _vm.showReconcile = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-regular fa-code-branch" }),
                      _vm._v("\n          Reconcile:\n          "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.reconciliationObject.VIBAN.slice(0, 15)) +
                            "..."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa-regular fa-xmark",
                        on: {
                          click: function ($event) {
                            return _vm.closeReconciliation()
                          },
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: ["content bg-light", { expanded: !_vm.isSidebarOpen }],
            staticStyle: { "padding-top": "5rem" },
          },
          [
            _vm.reconciliationObject == null || _vm.showReconcile == false
              ? _c(
                  "div",
                  [
                    _c(
                      "b-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "content-title" },
                          [
                            _c("b-row", [
                              _c("h1", [_vm._v("Reconciliation Ledger")]),
                            ]),
                            _vm._v(" "),
                            _c("b-row", [
                              _c("span", [
                                _vm._v(
                                  "Monitor and reconcile VIBANs with open transactions"
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "stats" },
                          _vm._l(_vm.stats, function (stat, index) {
                            return _c(
                              "b-col",
                              {
                                key: index,
                                on: {
                                  click: function ($event) {
                                    stat.status != null
                                      ? _vm.selectStatus(stat.status)
                                      : ""
                                  },
                                },
                              },
                              [
                                _c("div", [
                                  _c("span", { style: { color: stat.color } }, [
                                    _vm._v(_vm._s(stat.number)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(stat.title))]),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        this.totalOpenItems > 0
                          ? _c("div", { staticClass: "alert" }, [
                              _c("div", [
                                _c("i", {
                                  staticClass:
                                    "fa-regular fa-circle-exclamation",
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(this.totalOpenItems) +
                                      " open item(s) across " +
                                      _vm._s(this.totalPending) +
                                      " VIBAN(s) need attention"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    'Click "Reconcile" to match payments and orders.'
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "filters" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "filters-items" },
                          [
                            _c("div", { staticClass: "filter-item" }, [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v("Search VIBAN"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "filter-item-content",
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    "Search by VIBAN or client number...",
                                },
                                on: {
                                  input: function (event) {
                                    return (
                                      (_vm.paginationObj.search = _vm.sanitize(
                                        event.target.value
                                      )),
                                      _vm.submit()
                                    )
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.submit()
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c(
                                "div",
                                { staticClass: "filter-item" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title text-ellipsis",
                                    },
                                    [_vm._v("Status Filter")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "filter-item-content d-flex justify-content-between py-2 px-3",
                                      attrs: {
                                        id: "status-picker-link",
                                        href: "#",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fixed-span-size" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                this.paginationObj.pgstatus ==
                                                  null ||
                                                  this.paginationObj.pgstatus ==
                                                    "all"
                                                  ? "All Statuses"
                                                  : _vm.statusList.filter(
                                                      function (item) {
                                                        if (
                                                          item.code ==
                                                          this$1.paginationObj
                                                            .pgstatus
                                                        ) {
                                                          return item
                                                        }
                                                      }
                                                    )[0].label
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa-light fa-chevron-down",
                                        attrs: {
                                          size: "17px",
                                          id: "action-type-chevron",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "status-picker-link",
                                        triggers: "focus",
                                        placement: "bottom",
                                        "custom-class": "popover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        _vm._l(
                                          _vm.statusList,
                                          function (status, index) {
                                            return _c(
                                              "span",
                                              {
                                                key: index,
                                                class: [
                                                  "popover-option",
                                                  {
                                                    "popover-option-selected":
                                                      status.code == "all"
                                                        ? _vm.paginationObj
                                                            .pgstatus == null
                                                        : status.code ==
                                                          _vm.paginationObj
                                                            .pgstatus,
                                                  },
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectStatus(
                                                      status.code
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(status.label) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-item" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "filter-item-title text-ellipsis",
                                    },
                                    [_vm._v("Country Filter")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "filter-item-content d-flex justify-content-between py-2 px-3",
                                      attrs: {
                                        id: "country-picker-link",
                                        href: "#",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fixed-span-size" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                this.paginationObj.country ==
                                                  null ||
                                                  this.paginationObj.country ==
                                                    "all"
                                                  ? "All Countries"
                                                  : _vm.countryList.filter(
                                                      function (item) {
                                                        if (
                                                          item.code ==
                                                          this$1.paginationObj
                                                            .country
                                                        ) {
                                                          return item
                                                        }
                                                      }
                                                    )[0].label
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa-light fa-chevron-down",
                                        attrs: {
                                          size: "17px",
                                          id: "action-type-chevron",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "country-picker-link",
                                        triggers: "focus",
                                        placement: "bottom",
                                        "custom-class": "popover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        _vm._l(
                                          _vm.countryList,
                                          function (country, index) {
                                            return _c(
                                              "span",
                                              {
                                                key: index,
                                                class: [
                                                  "popover-option",
                                                  {
                                                    "popover-option-selected":
                                                      country.code ==
                                                      _vm.paginationObj.country,
                                                  },
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectCountry(
                                                      country.code
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(country.label) +
                                                    " " +
                                                    _vm._s(
                                                      country.code != null
                                                        ? "(" +
                                                            country.code +
                                                            ")"
                                                        : ""
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title text-ellipsis",
                                  },
                                  [_vm._v("Per Page")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "filter-item-content d-flex justify-content-between py-2 px-3",
                                    attrs: {
                                      id: "pagination-picker-link",
                                      href: "#",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "fixed-span-size" },
                                      [
                                        _vm._v(
                                          _vm._s(this.paginationObj.maxResults)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa-light fa-chevron-down",
                                      attrs: {
                                        size: "17px",
                                        id: "page-chevron",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      target: "pagination-picker-link",
                                      triggers: "focus",
                                      placement: "bottom",
                                      "custom-class": "popover",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      _vm._l(
                                        [10, 20, 30, 40, 50],
                                        function (resultsPerPage, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: index,
                                              class: [
                                                "popover-option",
                                                {
                                                  "popover-option-selected":
                                                    resultsPerPage ==
                                                    _vm.paginationObj
                                                      .maxResults,
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectPagination(
                                                    resultsPerPage
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(resultsPerPage) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "filter-btns" },
                          [
                            _c("b-col", [
                              _vm.totalResultsFiltered > 0
                                ? _c("span", [
                                    _vm._v(
                                      "Showing " +
                                        _vm._s(_vm.paginationObj.firstIndex) +
                                        " - " +
                                        _vm._s(
                                          _vm.totalResultsFiltered <
                                            _vm.paginationObj.maxResults
                                            ? _vm.totalResultsFiltered
                                            : _vm.currentPage *
                                                _vm.paginationObj.maxResults
                                        ) +
                                        " of " +
                                        _vm._s(_vm.totalResultsFiltered) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedItems.length > 0
                                ? _c("span", { staticClass: "selected" }, [
                                    _vm._v(
                                      _vm._s(_vm.selectedItems.length) +
                                        " selected"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedItems.length > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "clear",
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearSelection()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-classic fa-xmark",
                                      }),
                                      _vm._v("Clear"),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "1rem",
                                },
                              },
                              [
                                _vm.selectedItems.length > 0
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn-outline btn-tertiary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.exportSelected()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-classic fa-arrow-down-to-line",
                                        }),
                                        _vm._v(
                                          "Export Selected (" +
                                            _vm._s(_vm.selectedItems.length) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline button-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportFiltered()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v("Export Filtered"),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline button-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportAll()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v("Export All"),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-dark",
                                    on: {
                                      click: function ($event) {
                                        return _vm.refresh()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa-classic",
                                        "fa-arrows-rotate",
                                        { rotate: _vm.isLoading },
                                      ],
                                    }),
                                    _vm._v(
                                      "\n                Refresh\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.items != null
                      ? _c(
                          "div",
                          { staticClass: "card" },
                          [
                            _c("div", { staticClass: "p-6" }, [
                              _c("h2", [_vm._v("VIBAN Reconciliation Status")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.totalVibanAssigned) +
                                    " VIBAN" +
                                    _vm._s(
                                      _vm.totalVibanAssigned > 1 ? "s" : ""
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _vm.totalResultsFiltered > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "overflow-x": "auto" } },
                                  [
                                    _c("b-table", {
                                      staticStyle: { "margin-bottom": "0" },
                                      attrs: {
                                        responsive: "",
                                        items: _vm.items,
                                        fields: _vm.fields,
                                        "primary-key": "id",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "head(checkbox)",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox",
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                        id: "all",
                                                        name: "checkAll",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectAll(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "checkmark",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(checkbox)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox",
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        value: data.item,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelection(
                                                            $event,
                                                            data.item
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "checkmark",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(clientnumber)",
                                            fn: function (data) {
                                              return [
                                                data.item.Reference1 != ""
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.Reference1
                                                        )
                                                      ),
                                                    ])
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-weight":
                                                            "normal",
                                                        },
                                                      },
                                                      [_vm._v("—")]
                                                    ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(country)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  { staticClass: "btn-empty" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.VIBAN.substring(
                                                          0,
                                                          2
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(amount)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color:
                                                        data.item.Amount > 0
                                                          ? "#00a63e"
                                                          : data.item.Amount < 0
                                                          ? "#f54a00"
                                                          : "#6a7282",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "€" +
                                                        _vm._s(
                                                          Number(
                                                            data.item.Amount
                                                          ).toFixed(2)
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(openAmount)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color:
                                                        data.item.AmountCredit +
                                                          data.item.Amount <
                                                        0
                                                          ? "#00a63e"
                                                          : data.item
                                                              .AmountCredit +
                                                              data.item.Amount >
                                                            0
                                                          ? "#f54a00"
                                                          : "#6a7282",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "€" +
                                                        _vm._s(
                                                          Number(
                                                            data.item
                                                              .AmountCredit +
                                                              data.item.Amount
                                                          ).toFixed(2)
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(openItems)",
                                            fn: function (data) {
                                              return [
                                                Number(data.item.NbFactures) +
                                                  Number(
                                                    data.item.NbTransactions
                                                  ) >
                                                0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "grid",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1.2rem",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                Number(
                                                                  data.item
                                                                    .NbFactures
                                                                ) +
                                                                  Number(
                                                                    data.item
                                                                      .NbTransactions
                                                                  )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-weight":
                                                                "normal",
                                                              color: "#6a7282",
                                                              "font-size":
                                                                "0.9rem",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                data.item
                                                                  .NbTransactions
                                                              ) +
                                                                "P / " +
                                                                _vm._s(
                                                                  data.item
                                                                    .NbFactures
                                                                ) +
                                                                "O"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "1.2rem",
                                                        },
                                                      },
                                                      [_vm._v("0")]
                                                    ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(actions)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "d-flex",
                                                    staticStyle: {
                                                      gap: "0.5rem",
                                                      "justify-content":
                                                        "center",
                                                    },
                                                  },
                                                  [
                                                    data.item.Status != 2
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn-outline-light btn-blue",
                                                            attrs: {
                                                              id:
                                                                "view-rec-detail-btn-" +
                                                                data.index,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.getReconciliationDetail(
                                                                  data.item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa-regular fa-code-branch",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          target:
                                                            "view-rec-detail-btn-" +
                                                            data.index,
                                                          triggers: "hover",
                                                          placement: "top",
                                                          "custom-class":
                                                            "popover-btn",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    View reconciliation detail\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-outline-light",
                                                        attrs: {
                                                          id:
                                                            "view-transaction-btn-" +
                                                            data.index,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.navigate(
                                                              "/transactionledger/" +
                                                                data.item.VIBAN
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-regular fa-eye",
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          target:
                                                            "view-transaction-btn-" +
                                                            data.index,
                                                          triggers: "hover",
                                                          placement: "top",
                                                          "custom-class":
                                                            "popover-btn",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    View transaction\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(status)",
                                            fn: function (data) {
                                              return [
                                                Number(data.item.NbFactures) +
                                                  Number(
                                                    data.item.NbTransactions
                                                  ) >
                                                0
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-tertiary-full",
                                                        staticStyle: {
                                                          cursor: "default",
                                                          gap: "0.5rem",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                        },
                                                        style: {
                                                          color: "#a16207",
                                                          "background-color":
                                                            "#fefce8",
                                                          "border-color":
                                                            "#fef08a",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-light fa-clock",
                                                        }),
                                                        _vm._v(
                                                          "Pending (" +
                                                            _vm._s(
                                                              Number(
                                                                data.item
                                                                  .NbFactures
                                                              ) +
                                                                Number(
                                                                  data.item
                                                                    .NbTransactions
                                                                )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : Number(
                                                      data.item.NbFactures == ""
                                                        ? 0
                                                        : data.item.NbFactures
                                                    ) +
                                                      Number(
                                                        data.item
                                                          .NbTransactions == ""
                                                          ? 0
                                                          : data.item
                                                              .NbTransactions
                                                      ) ==
                                                      0 &&
                                                    data.item.AmountCredit == 0
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-tertiary-full",
                                                        staticStyle: {
                                                          cursor: "default",
                                                          gap: "0.5rem",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                        },
                                                        style: {
                                                          color: "#008236",
                                                          "background-color":
                                                            "#f0fdf4",
                                                          "border-color":
                                                            "#b9f8cf",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-light fa-circle-check",
                                                        }),
                                                        _vm._v("Clean"),
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn-tertiary-full",
                                                        staticStyle: {
                                                          cursor: "default",
                                                          gap: "0.5rem",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                        },
                                                        style: {
                                                          color: "#c10007",
                                                          "background-color":
                                                            "#fef2f2",
                                                          "border-color":
                                                            "#c1000773",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-light fa-triangle-exclamation",
                                                        }),
                                                        _vm._v("Needs Action"),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(lastActivity)",
                                            fn: function (data) {
                                              return [
                                                data.item.LastUpdate != ""
                                                  ? _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          new Date(
                                                            Date.parse(
                                                              data.item
                                                                .LastUpdate
                                                            )
                                                          ).toLocaleDateString(
                                                            "fr"
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.item.LastUpdate != ""
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#6a7282",
                                                          "font-size": "0.9rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            new Date(
                                                              Date.parse(
                                                                data.item
                                                                  .LastUpdate
                                                              )
                                                            ).toLocaleTimeString(
                                                              "it-IT"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("—")]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2222183799
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("hr"),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalResultsFiltered > 0
                              ? _c("b-row", { staticClass: "pagination" }, [
                                  _c(
                                    "button",
                                    {
                                      class: [
                                        "btn-outline-light btn",
                                        { inactive: _vm.currentPage == 1 },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          _vm.currentPage > 1 && _vm.previous()
                                        },
                                      },
                                    },
                                    [_vm._v("Previous")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "Page " +
                                        _vm._s(_vm.currentPage) +
                                        " of " +
                                        _vm._s(_vm.totalPages)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      class: [
                                        "btn-outline-light btn",
                                        {
                                          inactive:
                                            _vm.currentPage == _vm.totalPages,
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          _vm.currentPage < _vm.totalPages &&
                                            _vm.next()
                                        },
                                      },
                                    },
                                    [_vm._v("Next")]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      margin: "1rem",
                                      color: "#969696",
                                    },
                                  },
                                  [_c("span", [_vm._v("No results found")])]
                                ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "card empty" },
                          [_c("b-spinner", { attrs: { label: "Loading..." } })],
                          1
                        ),
                  ],
                  1
                )
              : _c("detail-reconciliation", {
                  attrs: { reconciliationObject: _vm.reconciliationObject },
                  on: { "close-reconciliation": _vm.closeReconciliation },
                }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }